import { Component, Input, OnInit } from '@angular/core';

import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';
import { EditorBookingItemEditStore } from '../editor-booking-item-edit/editor-booking-item-edit.store';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';


@Component({
    // tslint:disable-next-line:component-selector
    selector: '[eas-editor-booking-item-booking]',
    templateUrl: './editor-booking-item-booking.component.html',
    styleUrls: ['./editor-booking-item-booking.component.css'],
    standalone: false
})
export class EditorBookingItemBookingComponent implements OnInit {
  @Input() item: EditorBookingItem;

  constructor(
    private itemEditStore: EditorBookingItemEditStore,
    private itemDialogStore: EditorDialogStore
  ) {

  }

  ngOnInit() {

  }

  onEdit() {
    this.itemEditStore.startEditing(this.item.id, { name: 'userBookingSettings', value: null });
    this.itemDialogStore.editBookingItem();
    return false;
  }

  get cssClassName(): string {
    return this.item.userCanBook() ? 'option_row--set' : 'option_row--empty';
  }

  getSpecificBookingSettingsAdditionalInfo(): string {
    const specificBookingSettings = this.item.hideSpecificBookingSettings ? $localize `hidden` : $localize `shown`;
    return $localize `option name and venue of their bookable option are ${specificBookingSettings}`;
  }
}



